import * as React from 'react';
import { IPaginationOptions } from './pagination';

export interface IPagingArrowsProps {
    paging: IPaginationOptions;
    isLeftArrows: boolean;
    onPageSelect(page: number): void;
}

/// <summary>
/// Renders left or right page arrow content
/// </summary>
/// <returns>Content text</returns>
export class PagingArrows extends React.Component<IPagingArrowsProps, any> {

    render() {
        if (this.props.paging.items === 0) {
            return null;
        }

        return this.props.isLeftArrows
            ? this.renderLeftArrows()
            : this.renderRightArrows()
    }

    renderLeftArrows = () => {
        const isDisabled = this.props.paging.currentPage === 1;
        const classNames = "search-pagination-arrows search-pagination-arrows-left" + (isDisabled ? " search-pagination-arrows-disabled" : "");
        return (
            <div className={classNames}>
                <div className="search-pagination-arrows-item" onClick={() => isDisabled ? false : this.props.onPageSelect(1)}>
                    <svg>
                        <use xlinkHref="#arrow-double-left"></use>
                    </svg>
                    <p className="visually-hidden">First</p>
                </div>
                <div className="search-pagination-arrows-item" onClick={() => isDisabled ? false : this.props.onPageSelect(this.props.paging.currentPage - 1)}>
                    <svg>
                        <use xlinkHref="#arrow-left"></use>
                    </svg>
                    <p className="visually-hidden">Previous</p>
                </div>
            </div>
        );
    }

    renderRightArrows = (disabledClass?: string) => {
        const numberOfPages = this.props.paging.totalPages;
        const isDisabled = this.props.paging.currentPage === numberOfPages;
        const classNames = "search-pagination-arrows search-pagination-arrows-right" + (isDisabled ? " search-pagination-arrows-disabled" : "");

        return (
            <div className={classNames}>
                <div className="search-pagination-arrows-item" onClick={() => isDisabled ? false : this.props.onPageSelect(this.props.paging.currentPage + 1)}>
                    <p className="visually-hidden">Next</p>
                    <svg>
                        <use xlinkHref="#arrow-right"></use>
                    </svg>
                </div>
                <div className="search-pagination-arrows-item" onClick={() => isDisabled ? false : this.props.onPageSelect(numberOfPages)}>
                    <p className="visually-hidden">Last</p>
                    <svg>
                        <use xlinkHref="#arrow-double-right"></use>
                    </svg>
                </div>
            </div>
        );
    }
}